const user = JSON.parse(localStorage.getItem('user'));

export default {
  user: user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null }
}
